/**
 * Landing page — GSAP scroll-linked effects
 * Parallax, scrub reveals, images die meescrollen
 */

import { gsap, gsapHelpers } from "./gsap";

function initLandingEffects() {
  const page = document.querySelector(".landing-page");
  if (!page) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // Hero entrance — choreographed timeline (geen AOS-achtige fade)
  const heroContent = page.querySelector(".landing-hero__content");
  if (heroContent) {
    const els = [
      heroContent.querySelector(".landing-hero__badge"),
      heroContent.querySelector(".landing-hero__title"),
      heroContent.querySelector(".landing-hero__subtitle"),
      heroContent.querySelector(".landing-hero__cta"),
      heroContent.querySelector(".landing-hero__trust"),
    ].filter(Boolean);

    gsap.set(els, { opacity: 0, y: 24 });
    gsap.to(els, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      stagger: 0.12,
      ease: "power3.out",
      delay: 0.3,
    });
  }

  // Hero background — parallax + zoom (beeld beweegt mee met scroll)
  const heroParallax = document.getElementById("landing-hero-parallax");
  if (heroParallax) {
    gsapHelpers.parallax(heroParallax, -0.2);
    gsapHelpers.parallaxZoom(heroParallax, 1.15);
  }

  // Image showcase — scrub scale (zoomt in terwijl je scrollt)
  const scrubImages = page.querySelectorAll("[data-landing-scrub]");
  scrubImages.forEach((el) => {
    const type = el.dataset.landingScrub;
    const end = el.dataset.scrubEnd || "+=400";
    if (type === "scale") {
      gsapHelpers.scrubScaleReveal(el, {
        scaleFrom: parseFloat(el.dataset.scrubScale || 1.3),
        end,
      });
    }
    if (type === "clip") {
      const wrap = el.querySelector(".reveal-img-wrap") || el;
      if (wrap) gsapHelpers.scrubClipReveal(el, { direction: "bottom", end });
    }
  });

  // Parallax op feature images (verschillende snelheden)
  const parallaxImages = page.querySelectorAll("[data-landing-parallax]");
  parallaxImages.forEach((el) => {
    const speed = parseFloat(el.dataset.parallaxSpeed || "-0.25");
    gsapHelpers.parallax(el, speed);
  });
}

document.addEventListener("DOMContentLoaded", initLandingEffects);

export { initLandingEffects };
